import { render, staticRenderFns } from "./FuSplitPane.vue?vue&type=template&id=7474a58c&"
import script from "./FuSplitPane.vue?vue&type=script&lang=js&"
export * from "./FuSplitPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports